export const regularBotWinTexts = [
    "¡Te pasé por arriba!",
    "Sos de terror :)",
    "¡Te destrocé!",
    "¡Chiva chiva calenchu!",
    "¡Te mandé a pasear!",
    "Estabas menos cargado que Unión suave :)",
    "Andá a llorar a la Iglesia.",
    "Te mandé a la B.",
    "Ni el VAR te salva.",
    "Estás más perdido que Sampaoli.",
    "Te hice un Riquelme."
];
export const regularHumanWinTexts = [
    "Opa, estabas cargado, eh",
    "No me salió",
    "No me alcanzó",
    "¡Cómo zafaste!",
    "¡No puede ser!",
    "¡Qué mala suerte!",
    "Te la llevaste fácil.",
    "No lo vi venir.",
    "Hasta los grandes tienen días malos.",
    "Te dejé ganar.",
    "Te gané mentalmente.",
    "No quise humillarte."
];